import { log } from "../../../../common/Logging"
import { Buttons } from "../../../generic-sprites/Buttons"
import { GenericAssets } from "../../../generic-sprites/GenericAssets"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { TruthAssets, TruthClassAssets } from "../TruthAssets"
import { TruthPos } from "../TruthPos"

class HeadSprite {
    id: string
    symbol?: Phaser.Sprite
    clickArea: Phaser.Sprite
}

export class ClassSprite {
    sprite: Phaser.Sprite
    leader: Phaser.Sprite
    allHeads: Array<HeadSprite> = []
    clickedHeads: Array<HeadSprite> = []
    onHeadClicked: (totalClickedHeads: number) => void

    constructor(private game: Phaser.Game) {
        this.leader = Sprites.add(
            game,
            TruthAssets.LEADER,
            {y: TruthPos.leaderStartY()}
        )
        Sprites.centerInWorldXOnly(this.leader)
        this.sprite = Sprites.add(game, TruthClassAssets.CLASS, {y: TruthPos.classStartY()})
        Sprites.centerInWorldXOnly(this.sprite)

        this.setupHeads()
    }

    demakeHeads = () => {
        this.allHeads.forEach((head) => {
            head.symbol.destroy()
            Buttons.undoSpriteButton(head.clickArea)
        })
        this.clickedHeads = []
    }

    clearClickedHeads = () => {
        this.clickedHeads.forEach((head) => head.symbol.visible = false)
        this.clickedHeads = []
        if (this.onHeadClicked) {
            this.onHeadClicked(0)
        }
    }

    makeHeadsClickable = (asset: string) => {
        this.allHeads.forEach((head) => {
            head.symbol = Sprites.add(this.game, asset, {scale: 0.7})
            Sprites.centerSpriteInSprite(head.clickArea, head.symbol)
            head.symbol.visible = false
            Buttons.makeSpriteButton(head.clickArea, () => {
                const sizeBefore = this.clickedHeads.length
                this.clickedHeads = this.clickedHeads.filter((clickedHead) => clickedHead.id !== head.id)
                log.debug(`Size before: ${sizeBefore} size now: ${this.clickedHeads.length}`)
                head.symbol.visible = !head.symbol.visible
                if (sizeBefore === this.clickedHeads.length) {
                    this.clickedHeads.push(head)
                }
                if (this.onHeadClicked) {
                    this.onHeadClicked(this.clickedHeads.length)
                }
            })
        })
    }

    setupHeads = () => {
        let row = 0
        const makeHeadRow = (
            quantity: number, xRatio: number, yRatio: number, sizeRatio: number, spacingRatio: number,
            positionMod: { [key: number]: { xRatio?: number, yRatio?: number } }
        ) => {

            const boxSize = Scale.x(sizeRatio)
            let x = Scale.x(xRatio)
            const y = Scale.y(yRatio)
            const spacing = Scale.x(spacingRatio)
            for (let i = 0; i < quantity; i++) {
                let modX = 0
                let modY = 0
                if (positionMod[i] != null) {
                    modX = positionMod[i].xRatio ? Scale.x(positionMod[i].xRatio) : 0
                    modY = positionMod[i].yRatio ? Scale.y(positionMod[i].yRatio) : 0
                }
                const clickHead = Sprites.add(this.game, GenericAssets.WHITE_PIXEL, {x: x + modX, y: y + modY})
                clickHead.width = boxSize
                clickHead.height = boxSize
                x += boxSize + spacing
                clickHead.alpha = 0
                this.allHeads.push({id: `${row}${i}`, clickArea: clickHead})
            }
            row++
        }
        makeHeadRow(6, 0.295, 0.37, 0.065, 0.019, {
            3: {xRatio: -0.005},
            4: {xRatio: 0.005},
            5: {xRatio: 0.005},
        })
        makeHeadRow(8, 0.145, 0.46, 0.07, 0.023, {
            0: {yRatio: -0.02},
            3: {xRatio: -0.005},
            4: {xRatio: -0.01},
            5: {xRatio: -0.015},
            6: {xRatio: 0.005}
        })
        makeHeadRow(8, 0.095, 0.55, 0.09, 0.018, {
            0: {yRatio: -0.01},
            1: {yRatio: 0.01},
            2: {yRatio: 0.01, xRatio: -0.005},
            3: {xRatio: -0.02, yRatio: 0.01},
            5: {xRatio: -0.01, yRatio: -0.02},
            6: {xRatio: -0.02, yRatio: -0.01},
            7: {xRatio: -0.005, yRatio: -0.02},

        })
        makeHeadRow(8, 0.04, 0.67, 0.1, 0.018, {
            0: {yRatio: -0.02},
            1: {xRatio: -0.01, yRatio: 0.01},
            2: {xRatio: -0.02},
            4: {xRatio: 0.03, yRatio: 0.01},
            5: {xRatio: 0.03},
            6: {xRatio: 0.02},
            7: {xRatio: 0.01},

        })
    }

    handStand = () => this.sprite.loadTexture(TruthClassAssets.CLASS_HAND_STANDS)
    kissing = () => this.sprite.loadTexture(TruthClassAssets.CLASS_KISSING)
    sillyHats = () => this.sprite.loadTexture(TruthClassAssets.CLASS_SILLY_HATS)
    twoHands = () => {
        const image = Math.floor(Math.random() * 3)
        let asset
        if (image === 0) {
            asset = TruthClassAssets.CLASS_TWO_HANDS_A
        } else if (image === 1) {
            asset = TruthClassAssets.CLASS_TWO_HANDS_B
        } else {
            asset = TruthClassAssets.CLASS_TWO_HANDS_C
        }
        this.sprite.loadTexture(asset)
    }
    oneHand = () => {
        const image = Math.floor(Math.random() * 3)
        let asset
        if (image === 0) {
            asset = TruthClassAssets.CLASS_ONE_HAND_A
        } else if (image === 1) {
            asset = TruthClassAssets.CLASS_ONE_HAND_B
        } else {
            asset = TruthClassAssets.CLASS_ONE_HAND_C
        }
        this.sprite.loadTexture(asset)
    }
    resetClassImage = () => this.sprite.loadTexture(TruthClassAssets.CLASS)
}

